import React from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedin,
  FaYoutube,
} from "react-icons/fa";

const iconMap = {
  facebook: FaFacebookF,
  instagram: FaInstagram,
  // youtube: FaYoutube,
  // linkedin: FaLinkedin,
};

export default function SocialLinks({ links = [] }) {
  if (!links.length) return null;

  return (
    <div className="hidden items-center gap-2 lg:flex">
      {links.map((link) => {
        const Icon = iconMap[link.key];

        if (!Icon) return null;

        return (
          <a
            key={link.key}
            href={link.href}
            target="_blank"
            rel="noreferrer"
            aria-label={link.label}
            className="group relative inline-flex h-11 w-11 items-center justify-center overflow-hidden rounded-2xl border border-white/10 bg-white/10 text-white/80 shadow-lg shadow-black/10 transition duration-300 hover:-translate-y-0.5 hover:bg-white/15 hover:text-white"
          >
            <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent transition duration-700 group-hover:translate-x-full" />
            <Icon className="relative h-4 w-4" />
          </a>
        );
      })}
    </div>
  );
}